angular.module('rjmNg.directives').directive "applyMetricFormula", [
  "utils"
  (utils) ->
    restrict: "E"
    templateUrl: "directive.applyMetricFormula.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      currencies: "="
      metric: "="
      selectedMetrics: "="
      updateReport: '='
      updateMetricValidity: '='
      popover: '='
    controller: [
      () ->
        view = @

        view.initEditingMetric = () ->
          view.editingFormula =
            expression: utils.copy(view.metric.expression)
            expressionText: utils.copy(view.metric.expressionText)
            assignedType: utils.copy(view.metric.assignedType)
            valid: view.metric.valid
          view.metric.formulaChanged = false

        view.apply = () ->
          view.metric.expression = utils.copy(view.editingFormula.expression)
          view.metric.expressionText = utils.copy(view.editingFormula.expressionText)
          view.metric.assignedType = utils.copy(view.editingFormula.assignedType)
          view.metric.valid = view.editingFormula.valid

          view.updateMetricValidity()

          if view.updateReport?
            view.updateReport()

          view.popover.hide()

        view.cancel = () ->
          view.popover.hide()

        view.checkIfFormulaChanged = () ->
          expressionChanged = not angular.equals(
            view.metric.expression
            view.editingFormula.expression
          )
          expressionTextChanged = not angular.equals(
            view.metric.expressionText
            view.editingFormula.expressionText
          )
          typeChanged = not angular.equals(
            view.metric.assignedType
            view.editingFormula.assignedType
          )
          view.metric.formulaChanged = expressionChanged or expressionTextChanged or typeChanged

        view.$onInit = () ->
          view.initEditingMetric()

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch "view.editingFormula", view.checkIfFormulaChanged, true

      scope.$watch('view.popover.visible', (visible, old) ->
        if visible is false
          view.initEditingMetric()
      )
]
